webpackJsonp([175840686535948],{

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(29);
	
	var _Typography = __webpack_require__(13);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _reactFlexboxGrid = __webpack_require__(8);
	
	var _reactRouterDom = __webpack_require__(16);
	
	var _gatsbyImage = __webpack_require__(28);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Card = __webpack_require__(24);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardActions = __webpack_require__(25);
	
	var _CardActions2 = _interopRequireDefault(_CardActions);
	
	var _CardContent = __webpack_require__(26);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _pageTitle = __webpack_require__(82);
	
	var _pageTitle2 = _interopRequireDefault(_pageTitle);
	
	var _horizontalCard = __webpack_require__(81);
	
	var _horizontalCard2 = _interopRequireDefault(_horizontalCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InitiativesPage = function (_React$Component) {
		_inherits(InitiativesPage, _React$Component);
	
		function InitiativesPage() {
			_classCallCheck(this, InitiativesPage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		InitiativesPage.prototype.render = function render() {
			var features = this.props.data;
			console.log(features);
			var initiatives = [{
				title: "Feed the Rock Survey",
				featuredImage: features.rock,
				description: "We harness the power of memes to gather statistical data on unused meal plans in a viral, self propagating way. The scale of unused swipes is made more accessible by translating first into the Big Mac Index and then to a professional wrestler's 4,000 calorie a day diet."
			}, {
				title: "Open Kitchen",
				featuredImage: features.open_kitchen,
				description: "The Open Kitchen is a series of free community cooking classes where we show students foundational skills in cooking, sanitation, nutrition, and shopping. Each class is centered around  a cultural cuisine and after we cook together, we eat together."
			}, {
				title: "Packathon",
				featuredImage: features.packathon,
				description: "We redirect excess club funding to purchase ingredients and pack 150+ sandwiches for our fellow students. We stock existing community fridges around campus as a way to provide extra nutrition during stressful times, like final exams."
			},
			/*
	  {
	  title: "Love Through Food",
	  featuredImage: features.lovethroughfood,
	  description: "something"
	  },
	  */
			{
				title: "Trailblazers",
				featuredImage: features.trailblazers,
				description: "Undergraduate students learn the skills to plan, communicate, and execute change in social impact areas they are passionate about. They attend closely crafted workshops and travel across the country to lead workshops themselves.",
				link: "/trailblazers"
			}];
			return _react2.default.createElement(
				'div',
				{ style: this.props.transition && this.props.transition.style,
					className: 'section white slim' },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					null,
					_react2.default.createElement(
						'title',
						null,
						'Initiatives | Share Meals'
					)
				),
				_react2.default.createElement(_pageTitle2.default, {
					titles: {
						title: "Our Initiatives"
					}
				}),
				_react2.default.createElement(
					_reactFlexboxGrid.Grid,
					{ style: { paddingTop: "2rem" } },
					_react2.default.createElement(
						_reactFlexboxGrid.Row,
						null,
						initiatives.map(function (initiative, index) {
							return _react2.default.createElement(
								_reactFlexboxGrid.Col,
								{ md: 12,
									lg: 6,
									key: index,
									style: { marginTop: "8px",
										marginBottom: "8px"
									} },
								_react2.default.createElement(
									_horizontalCard2.default,
									{
										image: initiative.featuredImage ? initiative.featuredImage.childImageSharp.sizes.src : null,
										imagePadding: 0,
										title: initiative.title },
									_react2.default.createElement(
										'p',
										null,
										initiative.description,
										' ',
										initiative.link ? _react2.default.createElement(
											'a',
											{ href: initiative.link },
											'Read More'
										) : ''
									)
								)
							);
						})
					)
				)
			);
		};
	
		return InitiativesPage;
	}(_react2.default.Component);
	
	exports.default = InitiativesPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-initiatives-index-jsx-cf31ef8f3a846b13ddb2.js